import { HStack } from '@chakra-ui/react';
import _ from 'lodash';
import React from 'react';

import {
  OrganizationGQLType,
  TAccountTypeGQLType,
} from 'types/dashboard-core-gqlTypes.generated';

import { CsvDownloadButton } from 'packages/common-frontend/components/CsvDownloadButton';
import { FilterDatePicker } from 'packages/common-frontend/components/FilterDatePicker';
import { ExpensesFeesFilterMenus } from 'packages/statements/ui/ExpensesFeesFilterMenus';
import {
  ExpensesFeesTransactions,
  getCountersignersFilterOptions,
  getLiabilityAccountTypeOptions,
  LedgerTransactionWithAccountNameAndType,
} from 'packages/statements/ui/expensesFeesUtils';

interface ExpensesFeesTableHeaderProps {
  countersigners: Pick<
    OrganizationGQLType,
    'id' | 'name' | 'type' | 'slug' | 'industry'
  >[];
  ledgerAccountTypes: TAccountTypeGQLType[];
  selectedAccountTypes: TAccountTypeGQLType[] | [];
  selectedCountersigners: string[] | [];
  onChangeHandler: {
    accountTypes: React.Dispatch<
      React.SetStateAction<[] | TAccountTypeGQLType[]>
    >;
    countersigners: React.Dispatch<React.SetStateAction<[] | string[]>>;
  };
  startDate: Date | null;
  endDate: Date | null;
  setStartDate: React.Dispatch<React.SetStateAction<Date | null>>;
  setEndDate: React.Dispatch<React.SetStateAction<Date | null>>;
  transactions: ExpensesFeesTransactions;
  isLoading: boolean;
}

export const ExpensesFeesTableHeader: React.FC<ExpensesFeesTableHeaderProps> = ({
  countersigners,
  ledgerAccountTypes,
  selectedAccountTypes,
  selectedCountersigners,
  onChangeHandler,
  startDate,
  endDate,
  setStartDate,
  setEndDate,
  transactions,
  isLoading,
}) => {
  const liabilityAccountTypeOptions = getLiabilityAccountTypeOptions(
    ledgerAccountTypes,
  );
  const csvDataRows = _.flatten(
    _.map(transactions, (transactionsForDay) => {
      return _.map(transactionsForDay, (transaction) => {
        return {
          ...transaction,
          normalizedAmount: transaction.normalizedAmount.toFixed(2),
          balance: transaction.balance.toFixed(2),
        };
      });
    }),
  );
  const csvHeaders: {
    label: string;
    key: keyof LedgerTransactionWithAccountNameAndType;
  }[] = [
    { label: 'Date', key: 'postingDate' },
    { label: 'Countersigner', key: 'organizationName' },
    { label: 'Transaction', key: 'accountName' },
    { label: 'Amount', key: 'normalizedAmount' },
    { label: 'Balance', key: 'balance' },
  ];
  return (
    <HStack spacing="50px" justify="space-between">
      <HStack spacing="50px">
        <ExpensesFeesFilterMenus
          options={{
            accountTypes: liabilityAccountTypeOptions,
            countersigners: getCountersignersFilterOptions(countersigners),
          }}
          selectedOptions={{
            accountTypes: selectedAccountTypes,
            countersigners: selectedCountersigners,
          }}
          onChange={onChangeHandler}
        />
        <FilterDatePicker
          startDate={startDate}
          endDate={endDate}
          setStartDate={setStartDate}
          setEndDate={setEndDate}
        />
      </HStack>
      <CsvDownloadButton
        dataRows={csvDataRows}
        headers={csvHeaders}
        filenamePrefix="expenses-fees-ledger"
        buttonLabel="Export CSV of current view"
        dataIsLoading={isLoading}
      />
    </HStack>
  );
};
